import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="check-visibility"
export default class extends Controller {
  static targets = ["controlElement", "watchedElement"];

  connect() {
    this.waitForPageLoad();
  }

  waitForPageLoad() {
    window.onload = () => {
      this.checkElementVisibility();
    };
  }

  checkElementVisibility() {
    // Show the control button only if the watched element is not visible
    this.controlElementTarget.hidden = this.isElementVisible(this.watchedElementTarget);
  }

  isElementVisible(elem) {
    const rect = elem.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }
}
